import { CartItem } from "@swiggy-private/cart-types";

export function getCrossSellM2ItemProps(crossSellItem: CartItem) {
    return {
        itemId: crossSellItem.menu_item_id,
        name: crossSellItem.name,
        basePrice: crossSellItem.base_price,
        finalPrice: crossSellItem.final_price,
        imageId: crossSellItem.cloudinaryImageId,
        vegType: crossSellItem.isVeg,
        description: crossSellItem.description,
        price: crossSellItem.subtotal,
        itemDiscountPercentage: crossSellItem.item_discount_percentage,
    };
}
